export default "__VITE_ASSET__ae73c553__"